import React, { useState } from 'react'
import ConfigPostHistory from '../components/ConfigPostHistory/ConfigPostHistory'

const ConfigPostHistoryPage = () => {
  return (
    <>
      <ConfigPostHistory />
    </>
  )
}

export default ConfigPostHistoryPage
